/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NoInputs */

const th_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ใช่`)
};

const en_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const ja_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const zh_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`否`)
};

const es_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const id_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

const fr_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const tl_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi`)
};

const vi_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không`)
};

const ko_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아니요`)
};

const de_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

const ru_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const tr_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayır`)
};

const it_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pl_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie`)
};

const uk_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ні`)
};

const hi_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const ar_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا`)
};

const ms_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

const bn_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`না`)
};

const zh_tw2_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`否`)
};

const zh_hk2_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`否`)
};

const ur_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نہیں`)
};

const fa_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خیر`)
};

const sw_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapana`)
};

const nl_no = /** @type {(inputs: NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {NoInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const no = /** @type {((inputs?: NoInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NoInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_no(inputs)
	if (locale === "ja") return ja_no(inputs)
	if (locale === "zh") return zh_no(inputs)
	if (locale === "es") return es_no(inputs)
	if (locale === "pt") return pt_no(inputs)
	if (locale === "id") return id_no(inputs)
	if (locale === "fr") return fr_no(inputs)
	if (locale === "tl") return tl_no(inputs)
	if (locale === "vi") return vi_no(inputs)
	if (locale === "ko") return ko_no(inputs)
	if (locale === "de") return de_no(inputs)
	if (locale === "ru") return ru_no(inputs)
	if (locale === "tr") return tr_no(inputs)
	if (locale === "it") return it_no(inputs)
	if (locale === "pl") return pl_no(inputs)
	if (locale === "uk") return uk_no(inputs)
	if (locale === "hi") return hi_no(inputs)
	if (locale === "ar") return ar_no(inputs)
	if (locale === "ms") return ms_no(inputs)
	if (locale === "bn") return bn_no(inputs)
	if (locale === "zh-TW") return zh_tw2_no(inputs)
	if (locale === "zh-HK") return zh_hk2_no(inputs)
	if (locale === "ur") return ur_no(inputs)
	if (locale === "fa") return fa_no(inputs)
	if (locale === "sw") return sw_no(inputs)
	if (locale === "nl") return nl_no(inputs)
	return en_no(inputs)
});